import { api } from '@/lib/api'

import type { MDRDownloadLink, MDRReports } from './types'

/**
 * Get the reports for a tenant
 * @param tenant - The tenant ID
 * @returns The reports
 */
export const getReports = async (
	tenant: string,
	signal?: AbortSignal,
): Promise<Array<string>> => {
	const { data } = await api.get<MDRReports>(`/api/tenants/${tenant}/reports`, {
		signal,
	})

	// If the response is an array of files, return the files
	if ('files' in data) {
		return data.files
	}
	// Otherwise, return an empty array
	else {
		return []
	}
}

/**
 * Get the download link for a report
 * @param tenant - The tenant ID
 * @param report_name - The report name
 * @returns The download link
 */
export const getDownloadLink = async (
	tenant: string,
	report_name: string,
	signal?: AbortSignal,
): Promise<string> => {
	if (!report_name) throw new Error('Report name is required')

	const { data } = await api.get<MDRDownloadLink>(
		`/api/tenants/${tenant}/reports/${report_name}`,
		{
			signal,
		},
	)

	// If the response is a download link, return the download link
	if ('download_link' in data) {
		return data.download_link
	}
	// Otherwise, return an empty string
	else {
		return ''
	}
}
